<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>
        <div>
          <div class="info--text">
            <v-icon medium>router</v-icon>
            <strong>Vegetative Monitoring</strong>
          </div>
          <div class="body-2">
            Summary
          </div>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-card v-if="wideForm" class="card-bg-4">
      <PlotDataSourceSurveySummary class="mb-2" data-ui-component="Survey Summary" :dataSource="vegetativePlotDataSource" />
      <v-layout>
        <v-flex xs6 class="pr-1">
          <PlotDataSourceInformationTable data-ui-component="Plot Metadata" :editForm="editForm" :dataSource="vegetativePlotDataSource" />
        </v-flex>
        <v-flex xs6 class="pl-1" data-ui-component="Aliases and Plot Hierarchy">
          <PlotDataSourceSpecimenaSummary class="mb-1" data-ui-component="Specimen Count" :dataSource="vegetativePlotDataSource" />
          <!-- <Aliases class="ma-2 card-bg-1 elevation-1 card-border" :editForm="editForm" /> -->
          <PlotAliases data-ui-component="Aliases" :editForm="editForm" :dataSourceIndex="vegetativePlotDataSourceIndex" />
          <!-- <template data-ui-component="Plot Hierarchy" /> -->
        </v-flex>
      </v-layout>
    </v-card>
    <v-card v-else class="card-bg-4">
      <PlotDataSourceSurveySummary class="mb-2" :dataSource="vegetativePlotDataSource" />
      <PlotDataSourceSpecimenaSummary class="mb-2" :dataSource="vegetativePlotDataSource" />
      <PlotDataSourceInformationTable class="mb-2" :editForm="editForm" :dataSource="vegetativePlotDataSource" />
      <PlotAliases :editForm="editForm" :dataSourceIndex="vegetativePlotDataSourceIndex" />
    </v-card>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const datasource = createNamespacedHelpers('datasource')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import PlotDataSourceSurveySummary from './Details/PlotDataSourceSurveySummary'
  import PlotDataSourceSpecimenaSummary from './Details/PlotDataSourceSpecimenaSummary'
  import PlotAliases from './Details/PlotAliases'
  import PlotDataSourceInformationTable from './Details/PlotDataSourceInformationTable'
  // import Aliases from '@/components//ManageAliases/Aliases'

  export default {
    components: {
      PlotDataSourceSurveySummary,
      PlotDataSourceSpecimenaSummary,
      PlotAliases,
      PlotDataSourceInformationTable,
    },
    props: {
      editForm: Boolean,
      wideForm: Boolean,
    },
    computed: {
      ...datasource.mapGetters(['dataSourceIndex']),
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData', 'currentFeatureDataSourceIndexByType']),
      // data source for plot data tabs and summary details
      vegetativePlotDataSource() {
        const data = this.currentFeatureDataSourceData(SOURCE_TYPES.vegetativeMonitoringEnvirodata)
        return data && data.plotData
      },
      // data source index for alias information
      vegetativePlotDataSourceIndex() {
        const sourceId = this.vegetativePlotDataSource && this.vegetativePlotDataSource.Id
        if (sourceId == null) {
          return {}
        }
        return (this.dataSourceIndex && this.dataSourceIndex[SOURCE_TYPES.vegetativeMonitoringEnvirodata] && this
          .dataSourceIndex[
            SOURCE_TYPES.vegetativeMonitoringEnvirodata][sourceId]) || {}
      },
    },
  }
</script>